export class LocationScannedEvent {
  constructor(public readonly locationCode: string) {}
}
